import { Navigate } from 'react-router-dom';

import { getAccessToken } from '@/api/tokens.helper';
import { isAccessTokenValid } from '@/auth/jwt';
import { FormButton } from '@/components/FormInputs/FormInputs';
import { ROUTES } from '@/router/routes';

// Subscriptions tab of the main Vessel Haven app (external — domain from env).
const HAVEN_SETTINGS_URL = `${import.meta.env.VITE_APP_WEB_URL}/settings?tab=subscriptions`;

export const UnauthorizedPage = () => {
  if (isAccessTokenValid(getAccessToken())) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return (
    <main style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
      <div style={{ textAlign: 'center' }}>
        <h1>Unauthenticated</h1>
        <p>
          Your session is missing, invalid, or expired. Please open the app again using a valid
          link.
        </p>
        <FormButton
          onClick={() => (window.location.href = HAVEN_SETTINGS_URL)}
          style={{ margin: '16px auto 0' }}
        >
          Go to Vessel Haven
        </FormButton>
      </div>
    </main>
  );
};
